import React, { ReactNode } from 'react';
import { useHeap } from '../../hooks/useHeap';
import { useSupportBot } from './hooks/useSupportBot';

export const IntegrationsConfigurationManager = ({ children }: { children: ReactNode }) => {
  useHeap();
  useSupportBot();

  return <>{children}</>;
};
